import { TextField, TextFieldProps } from "@mui/material";

const EcnInput = (props: TextFieldProps) => {
  return <TextField {...props} />;
};

export default EcnInput;
